import { createFileRoute } from "@tanstack/react-router";
import React, { useState } from "react";
import { MaterialInfoCard } from "@/src/components/materials/MaterialInfoCard";
import { MaterialSearch } from "@/src/components/materials/MaterialSearch";
import { Spinner } from "@/src/components/ui/spinner";
import { getMaterialById } from "@/src/api/material";
import { useQuery } from "@tanstack/react-query";

export const Route = createFileRoute("/_tools/tools/materials/")({
  component: MaterialTestPage,
});

function MaterialSearchFormWrapper({
  value,
  onChange,
  label,
}: {
  value?: string;
  onChange: (id: string) => void;
  label?: string;
}) {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };
  return (
    <form onSubmit={handleSubmit} className="w-full">
      <MaterialSearch value={value} onChange={onChange} label={label} />
    </form>
  );
}

function MaterialTestPage() {
  const [selectedId, setSelectedId] = useState<string | undefined>(undefined);
  const { data: material, isLoading } = useQuery({
    queryKey: ["material", selectedId],
    queryFn: () => getMaterialById({ data: { id: selectedId! } }),
    enabled: !!selectedId,
  });

  return (
    <div className="w-full flex flex-col gap-8 p-6 pb-20">
      <div className="max-w-3xl mx-auto w-full">
        <MaterialSearchFormWrapper
          value={selectedId}
          onChange={setSelectedId}
          label="Search for a material"
        />
      </div>
      {isLoading && (
        <div className="flex justify-center items-center py-8">
          <Spinner size={28} />
        </div>
      )}
      {material && (
        <div className="max-w-3xl mx-auto w-full">
          <MaterialInfoCard material={material} />
        </div>
      )}
      {!isLoading && selectedId && !material && (
        <div className="text-muted-foreground max-w-3xl mx-auto w-full">Material not found.</div>
      )}
    </div>
  );
}
